import classnames from 'classnames';
import React, { useCallback, useMemo } from 'react';

import styles from './SidebarMenu.module.scss';
import { Scrollable } from '../scrollable/Scrollable';
import { OverflowTooltip } from '../tooltip';

const { french, primary, lightGrey } = styles;

export interface SidebarMenuOption {
    id: string;
    label: string;
    element: JSX.Element;
}

export interface SidebarMenuProps {
    sections: SidebarMenuOption[];
    selected: string;
    testId: string;
    menuDisabled: boolean;
    openSection: (id: string) => void;
    sidebarWidth?: number;
}

export const SidebarMenu: React.FC<SidebarMenuProps> = ({ sections, selected, openSection, testId, menuDisabled, sidebarWidth = 150 }) => {
    const selectedElement = useMemo(() => sections.find(({ id }) => id === selected)?.element || null, [sections, selected]);
    const getSectionColour = useCallback((id: string) => {
        if (menuDisabled) {
            return lightGrey;
        }
        return selected === id ? french : primary;
    }, [menuDisabled, selected]);

    const selectSection = useCallback((id: string) => !menuDisabled && openSection(id), [menuDisabled, openSection]);

    return (
        <div className={styles.sidebarMenuWrapper} data-testid={`sidebar-menu-${testId}`}>
            <div className={styles.menuWrapper} style={{ minWidth: `${sidebarWidth}px`, maxWidth: `${sidebarWidth}px`, width: `${sidebarWidth}px` }}>
                <Scrollable>
                    {sections.map(({ id, label }, index) => (
                        <div key={index} className={styles.sectionWrapper} style={{ color: getSectionColour(id) }} onClick={() => selectSection(id)}>
                            <OverflowTooltip overlayText={label} className={classnames(styles.sectionLabel, { [styles.sectionLabelDisabled]: menuDisabled })} />
                        </div>
                    ))}
                </Scrollable>
            </div>
            <div className={styles.scrollableContentWrapper} style={{ width: `calc(100% - ${sidebarWidth + 1}px)` }}>
                {selectedElement}
            </div>
        </div>
    );
};
